import { render, staticRenderFns } from "./CustomAddress.vue?vue&type=template&id=ce9b2214&scoped=true&lang=html&"
import script from "./CustomAddress.vue?vue&type=script&lang=js&"
export * from "./CustomAddress.vue?vue&type=script&lang=js&"
import style0 from "./CustomAddress.vue?vue&type=style&index=0&id=ce9b2214&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9b2214",
  null
  
)

export default component.exports